import { render } from "./CareerPath.vue?vue&type=template&id=228296be"
import script from "./CareerPath.vue?vue&type=script&lang=js"
export * from "./CareerPath.vue?vue&type=script&lang=js"

import exportComponent from "/home/jym/canvas_lms/lms/canvas/course_category_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__